<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import {clearStorage, getStorage, getToken} from "@/utils/auth";
// import chat from "@/utils/im";
import TIM from "@tencentcloud/chat";
import store from "@/store";
import TIMUploadPlugin from "tim-upload-plugin";
import {Message} from "element-ui";
let chat = TIM.create({
  SDKAppID: 1600115678
})
let msgAudio = null
let postAudio = null
export default {
  name: 'App',
  data() {
    return {
      IMLoginEd: false,
      audioClicked: false
    }
  },
  watch:{
    audioClicked(newVal, oldVal) {
      console.log('audioClicked', newVal, oldVal)
      if (newVal) {
        document.removeEventListener('click', this.audioClickListener())
      }
    }
  },
  mounted() {
    msgAudio = document.createElement('audio')
    postAudio = document.createElement('audio')
    msgAudio.src = require('@/assets/static/new-msg.mp3')
    postAudio.src = require('@/assets/static/new-post.mp3')

    document.addEventListener('click', this.audioClickListener())

    console.log('chat', store.getters.chat)
    chat.registerPlugin({
      'tim-upload-plugin': TIMUploadPlugin
    });

    store.commit('user/SET_CHAT', chat)

    chat.on(TIM.EVENT.SDK_READY, this.handleSDKReady)
    chat.on(TIM.EVENT.SDK_NOT_READY, this.handleSDKNotReady)
    chat.on(TIM.EVENT.KICKED_OUT, this.handleKickedOut)
    this.$EventBus.$on('initIM', () => {
      this.initIM()
    })
    this.$EventBus.$on('exitIM', () => {
      this.exitIM()
    })
    if (getToken() && !chat.isReady()) {
      this.initIM()
    }
  },
  beforeDestroy() {
    chat.off(TIM.EVENT.SDK_READY, this.handleSDKReady)
    chat.off(TIM.EVENT.SDK_NOT_READY, this.handleSDKNotReady)
    chat.off(TIM.EVENT.KICKED_OUT, this.handleKickedOut)
    chat.off(TIM.EVENT.MESSAGE_RECEIVED, this.handleMsgReceived)
    this.$EventBus.$off('initIM')
    if (!this.audioClicked) {
      document.removeEventListener('click', this.audioClickListener())
    }
  },
  methods: {
    audioClickListener() {
      console.log('audioClicked-click')
      this.audioClicked = true
    },
    handleMsgReceived(e) {
      console.log('handleMsgReceived', e)
      for (const m in e.data) {
        const {payload, conversationType} = e.data[m]
        if (payload.description === 'postUpdate') {
          if (this.audioClicked && getStorage('user_type') != 'circle_admin') {
            console.log('audio-play')
            postAudio.currentTime = 0
            postAudio.play()
            this.$EventBus.$emit('updatePost')
          }
          // return
        }
        if (conversationType == 'C2C' && payload.description == 'custom') {
          msgAudio.currentTime = 0
          msgAudio.play()
          // 有私信
          if (window.location.hash != '#/private/message') {
            this.$EventBus.$emit('addUnReadNums')
          }
        }
      }
    },
    handleSDKReady() {
      // 登录后才会触发初始化完成
      this.$EventBus.$emit('handleSDKReady')
    },
    handleSDKNotReady() {
      // 初始化未完成
      this.IMLoginEd = false
    },
    handleKickedOut(e) {
      this.IMLoginEd = false
      clearStorage()
      localStorage.clear()
      Message({
        message: '登录异常，请重新登录',
        type: 'warning',
        offset: 360
      })
      store.commit('user/SET_CHAT', null)
      this.$router.push('/login')
      console.log('handleKickedOut', e.data.type)
      switch (e.data.type) {
        case TIM.TYPES.KICKED_OUT_MULT_ACCOUNT:
          console.log('多实例登录')
          break
        case TIM.TYPES.KICKED_OUT_MULT_DEVICE:
          console.log('多设备登录')
          break
        case TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED:
          console.log('userSig过期')
          break
        case TIM.TYPES.KICKED_OUT_REST_API:
          console.log('REST_API kick接口踢出')
          break
        default:
          break
      }
    },
    exitIM() {
      this.IMLoginEd = false
      chat.destroy().then(() => {
        store.commit('user/SET_CHAT', null)
        chat = null
      }).catch(() => {})
    },
    initIM() {
      console.log('initIM-1')
      if (this.IMLoginEd) {
        return
      }
      // IM
      if (getToken() && chat) {
        console.log('initIM-2', chat)
        store.commit('user/SET_CHAT', chat)
        this.IMLoginEd = true
        const userSig = getStorage('im_sign')
        const userID =getStorage('u_code')
        chat.login({
          userID: userID,
          userSig: userSig
        }).then(() => {
          console.log('initIM-2-1')
          if (getStorage('now_circle_code')) {
            console.log('initIM-2-2')
            chat.joinGroup({
              groupID: getStorage('now_circle_code')
            }).then(() => {
              console.log('initIM-2-3')
              chat.on(TIM.EVENT.MESSAGE_RECEIVED, this.handleMsgReceived)
            })
          }
        }).catch((err) => {
          console.log('im-login-catch', err)
        })
      } else if (!chat) {
        console.log('initIM-3')
        chat = TIM.create({
          SDKAppID: 1600096020
        })
        chat.registerPlugin({
          'tim-upload-plugin': TIMUploadPlugin
        })
        store.commit('user/SET_CHAT', chat)

        const userSig = getStorage('im_sign')
        const userID =getStorage('u_code')
        chat.login({
          userID: userID,
          userSig: userSig
        }).then(() => {
          console.log('initIM-3-1')
          if (getStorage('now_circle_code')) {
            console.log('initIM-3-2')
            chat.joinGroup({
              groupID: getStorage('now_circle_code')
            }).then(() => {
              console.log('initIM-3-3')
              chat.on(TIM.EVENT.MESSAGE_RECEIVED, this.handleMsgReceived)
            })
          }
        })
      }
    },
  }
}
</script>

<style>
body{
  padding: 0;margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background:
      linear-gradient(180deg, #FAF5F5 0%, #FFFFFF 100%) 0 0 / 100% 240px no-repeat,
      #FFFFFF; /* 底部纯色 */
}
.el-select-dropdown .el-select-dropdown__wrap .el-select-dropdown__list .el-select-dropdown__item{font-size: 12px;}
</style>
